import React from "react";
import { Navbar } from "../components/Navbar";
import { Hero } from "../components/Hero";
import { TaglineMarquee } from "../components/TaglineMarquee";
import { AboutColac } from "../components/AboutColac";
import { WhatsOn } from "../components/WhatsOn";
import { UpcomingEvents } from "../components/UpcomingEvents";
import { PrivateHire } from "../components/PrivateHire";
import { Gallery } from "../components/Gallery";
import { Testimonials } from "../components/Testimonials";
import { Faq } from "../components/Faq";
import { Footer } from "../components/Footer";
import SeoEventsSchema from "../components/SeoEventsSchema";

export default function Landing() {
  return (
    <div className="grain min-h-screen bg-[#0A0A0A] text-[#FDFBF7]" data-testid="landing-page">
      <SeoEventsSchema />
      <Navbar />
      <Hero />
      <TaglineMarquee />
      <AboutColac />
      <WhatsOn />
      <UpcomingEvents />
      <PrivateHire />
      <Gallery />
      <Testimonials />
      <Faq />
      <Footer />
    </div>
  );
}
